const status = {
  CREATED: 'CREATED',
  ACTIVATED: 'ACTIVATED'
}

export default status
